module.exports = __webpack_public_path__ + "static/media/26UNRWA10.c1bbe8a5.jpg";